import type { Lang, ModuleStringFallback } from '@platform/core/types';

/**
 * Підпис, перейменований налаштуваннями простору (ADR-023): злите визначення сервера несе новий підпис мовою інтерфейсу, якого немає в
 * опублікованому визначенні пакета, — тоді він важливіший за рядок пакета i18n. Повертає цей підпис або undefined (не перейменовано,
 * готовий рядок замість локалізованого тексту, немає опублікованого визначення для порівняння). Чиста функція.
 */
export function overriddenText(merged: ModuleStringFallback, published: ModuleStringFallback | false, lang: Lang): string | undefined {
  if (published === false || !merged || typeof merged === 'string') return undefined;
  const value = merged[lang];
  if (!value) return undefined;
  const before = published && typeof published !== 'string' ? published[lang] : published;
  return value !== (before ?? undefined) ? value : undefined;
}
